module.exports = __webpack_public_path__ + "static/img/city.cec76cb4.png";